module.exports = __webpack_public_path__ + "media/images/map_preview_landscape-d4d39cc5314b999af52bcae7f4f6058a.png";